import * as routes from './routes';

export const publicPaths = [
  routes.privacyPolicy,
  `${routes.invitation}/:invitationId`,
  `${routes.loginScreen}/:invitationId?`,
  routes.loginSSOScreen,
  `${routes.registrationScreen}/:invitationId`,
  `${routes.setNewPassword}/:uid/:token`,
  routes.authenticationSetup,
  routes.loginMfa,
  `${routes.publicCulturalProjectProcess}/:projectId`,
  `${routes.culturalProjectProcess}/:projectId/:userId?`,
  `${routes.nomineeReject}/:id`,
  `${routes.nomineeReport}/:id`,
  `${routes.feedbackProcess}/:nominee`,
];

const dashboardPortfolioPaths = [
  '',
  `${routes.masterDashboardDetails}/:masterDashboardId?`,
  `${routes.masterDashboardKeyArea}/:keyAreaId`,
  `${routes.masterDashboardsList}`,
];

const projectJournalsPaths = ['', `${routes.projectJournalsEntries}/:journalId`];

const personalJournalsPaths = ['', ':journalId', `:journalId/${routes.personalJournalReport}`];

export const privatePaths = [
  routes.home,
  routes.organisationsList,
  routes.accountSettings,
  routes.organisationOverview,
  `/:organisationId?/${routes.newCulturalProject}/:id?`,
  `/:organisationId?/${routes.newProjectUsers}/:id`,
  `/:organisationId?/${routes.culturalProjectAdvancedSettings}/:id`,
  `/:organisationId?/${routes.dashboard}/:id`,
  `/:organisationId/${routes.dashboardBucket}/:id`,
  `/:organisationId/${routes.personalTracker}/:projectId`,
  `/:organisationId/${routes.newFeedbackFramework}/:id?`,
  `/:organisationId/${routes.newFeedbackRecipient}/:id`,
  `/:organisationId/${routes.viewNominees}/:frameworkId/:userId`,
  `${routes.feedbackNominees}/:frameworkId`,
  `${routes.recipientReject}/:frameworkId/:id`,
  `${routes.report}/:frameworkId/:id`,
  `${routes.teamReport}/:organisationId/:id`,
  `${routes.projectList}/:organisationId`,
  `${routes.manageUsers}/:organisationId?`,
  `${routes.personalProjects}/:organisationId`,
  `${routes.actionTracker}/:organisationId`,
  `${routes.createProject}/:organisationId`,
  `${routes.securitySettings}/:organisationId`,
  `${routes.activityLog}/:organisationId`,
  ...dashboardPortfolioPaths.map((path) => `${routes.dashboardPortfolio}/:organisationId/${path}`),
  ...projectJournalsPaths.map((path) => `${routes.projectJournals}/:organisationId/${path}`),
  ...personalJournalsPaths.map((path) => `${routes.personalJournals}/:organisationId/${path}`),
];
